import { isEqual } from "lodash";
import { useRef } from "react";
// * Copied from https://github.com/apollographql/react-apollo/blob/master/packages/hooks/src/utils/useDeepMemo.ts
export function useDeepMemo(memoFn, key) {
    const ref = useRef(null); // verify this
    if (!ref.current || !isEqual(key, ref.current.key))
        ref.current = {
            key,
            value: memoFn(),
        };
    return ref.current.value;
}
//# sourceMappingURL=use-deep-memo.js.map